import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService
  ) {

  }

  private denyAccess(message: string, targetRoute: string) {
    this.toastr.error(message, 'Acceso denegado');
    this.router.navigate([targetRoute]);
    return false;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const allowedRoles = (route.data?.['allowedRoles'] as number[] | undefined) || [];
    const requiresActiveStatus = route.data?.['requiresActiveStatus'] !== false;
    const requiresStudentContext = route.data?.['requiresStudentContext'] === true;

    if (!this.authService.hasToken() || !this.authService.isLoggedIn || !this.authService.hasResolvedUser()) {
      this.authService.clearSession();
      this.router.navigate(['/login']);
      return false;
    }

    if (requiresActiveStatus && !this.authService.isActive()) {
      this.authService.clearSession();
      return this.denyAccess(
        'Su usuario no se encuentra habilitado para ingresar al sistema',
        '/login'
      );
    }

    if (allowedRoles.length > 0 && !this.authService.hasRole(allowedRoles)) {
      return this.denyAccess(
        'No tiene permisos para acceder a esta pagina',
        this.authService.getDefaultRoute()
      );
    }

    if (requiresStudentContext && !this.authService.hasStudentContext()) {
      return this.denyAccess(
        'No se encontro un estudiante valido para esta sesion',
        '/login'
      );
    }

     return true;
  }
  
}
